export const useLeaderboardScroll = () => {
  const isScrolling = useState<boolean>('leaderboard-scrolling', () => false);

  return {
    isScrolling: readonly(isScrolling),
    setScrolling: (value: boolean) => {
      isScrolling.value = value;
    }
  };
};
